export default __webpack_public_path__ + "static/media/ultra teb final white.a0f9608a.svg";